import i18n from 'modules/core/lib/i18n'

import { PLANNING_TOOL } from 'modules/time_planning/store/models/PlanningVersion'

export const planningToolOptions = (hasShiftManagement = true) => {
  const defaultOptions = [
    {
      value: PLANNING_TOOL.contractHours,
      label: i18n.t('time_planning.planning_versions.forms.planning_tools.contract_hours'),
    },
    {
      value: PLANNING_TOOL.workSchedule,
      label: i18n.t('time_planning.planning_versions.forms.planning_tools.work_schedule'),
    },
  ]

  const shiftManagementOption = [
    {
      value: PLANNING_TOOL.shiftManagement,
      label: i18n.t('time_planning.planning_versions.forms.planning_tools.shift_management'),
    },
  ]

  if (hasShiftManagement) {
    return [...defaultOptions, ...shiftManagementOption]
  }

  return defaultOptions
}
